import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {ButtonToolbar} from 'react-bootstrap'
import {infoStatus} from '../../core/redux/status'
import LoaderButton from '../../core/components/LoaderButton'
import Card from '../../core/components/Card'
import {sendResetPasswordDemand} from '../actions'
import i18n from '../i18n'

class ResetPasswordDemandCard extends Component {
    static propTypes = {
    }

    _sendCmd(event) {
        const {dispatch, authenticated} = this.props

        return dispatch(sendResetPasswordDemand({email: authenticated.login})).then(() => {
            return dispatch(infoStatus(i18n.resetPasswordEmailSent))
        })
    }

    render() {
        const {dispatch, authenticated, ...others} = this.props

        const requiredLabel = (label) => (
            <span>{label} <i>*</i></span>
        )

        const header = (
            <h5>{i18n.changePassword}</h5>
        )

        return (
            <Card
                header={header}
                {...others}>
                <ButtonToolbar>
                    <LoaderButton
                        bsStyle='primary'
                        bsSize='large'
                        onClick={(e) => this._sendCmd(e)}>
                        {i18n.resetPassword}
                    </LoaderButton>
                </ButtonToolbar>
            </Card>
        )
    }
}

ResetPasswordDemandCard = connect((state) => ({
    authenticated: state.user.authenticated
}))(ResetPasswordDemandCard)

export default ResetPasswordDemandCard


// WEBPACK FOOTER //
// ./lib/user/components/ResetPasswordDemandCard.js